import withStyles from 'isomorphic-style-loader/withStyles';
import React from 'react';
import PTs from 'prop-types';

import s from './AspectImage.scss';

class AspectImage extends React.Component {
  static propTypes = {
    altText: PTs.string.isRequired,
    aspectRatio: PTs.string.isRequired,
    src: PTs.string.isRequired,
    width: PTs.string,
  };

  static defaultProps = {
    width: null,
  };

  extract = aspectRatio => {
    const array = aspectRatio.split(':');
    const width = parseInt(array[0], 10);
    const height = parseInt(array[1], 10);

    return `${height / width}%`;
  };

  render() {
    const { src, aspectRatio, width, altText } = this.props;

    const paddingTop = this.extract(aspectRatio);

    return (
      <div
        style={{
          width,
        }}
      >
        <div className={s.imageContainer} style={{ paddingTop }}>
          <img alt={altText} className={s.image} src={src} />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(AspectImage);
